import React from 'react';
import PropTypes from 'prop-types';
import { IconFromSVG } from '../IconFromSVG/IconFromSVG';
import './IconWithRoundBorder.scss';

export const IconWithRoundBorder = ({ iconSrc, iconWidth }) => {
  return (
    <div className="icon-width-round-border">
      <IconFromSVG src={iconSrc} width={iconWidth} marginRight="0" />
    </div>
  );
};

IconWithRoundBorder.propTypes = {
  iconSrc: PropTypes.string.isRequired,
  iconWidth: PropTypes.string.isRequired,
};